import { InternalAxiosRequestConfig } from 'axios';
import i18n from 'i18next';

export async function injectLanguageInterceptor(config: InternalAxiosRequestConfig) {
  const language = i18n.language;

  config.headers = config.headers ?? {};
  config.headers['Accept-Language'] = language;
  return config;
}
